import { Coins, WalletCards } from "lucide-react";

function formatJPY(value) {
  return `¥${Number(value || 0).toLocaleString()}`;
}

const walletCopy = {
  en: {
    title: "Member wallet",
    description: "Credit and Points can be used for your next ride. Maximum redemption is 10% of this booking.",
    credit: "Credit",
    points: "Points",
    cap: "10% cap",
    useCredit: "Use Credit (JPY)",
    usePoints: "Use Points",
    note: "1 point = ¥1. Member bookings earn 3% to 5% points after the service is completed. Points are valid for 180 days.",
  },
  ja: {
    title: "会員ウォレット",
    description: "クレジットとポイントは次回のご利用に使用できます。この予約で利用できる上限は予約金額の10%です。",
    credit: "クレジット",
    points: "ポイント",
    cap: "10% 上限",
    useCredit: "クレジットを利用（JPY）",
    usePoints: "ポイントを利用",
    note: "1ポイント = ¥1。会員予約では、サービス完了後に会員ランクに応じて3%から5%のポイントが付与されます。ポイント有効期限は180日です。",
  },
  zh: {
    title: "会员钱包",
    description: "余额和积分可用于下次用车。本次预约最多可抵扣订单金额的10%。",
    credit: "余额",
    points: "积分",
    cap: "10%抵扣上限",
    useCredit: "使用余额（JPY）",
    usePoints: "使用积分",
    note: "1积分 = ¥1。会员预约在服务完成后，可按会员等级获得3%至5%的积分返还。积分有效期180天。",
  },
  zhHant: {
    title: "會員錢包",
    description: "餘額和積分可用於下次用車。本次預約最多可抵扣訂單金額的10%。",
    credit: "餘額",
    points: "積分",
    cap: "10%抵扣上限",
    useCredit: "使用餘額（JPY）",
    usePoints: "使用積分",
    note: "1積分 = ¥1。會員預約在服務完成後，可按會員等級獲得3%至5%的積分返還。積分有效期180天。",
  },
};

export default function RetailWalletSummary({
  lang = "en",
  member,
  grossTotal = 0,
  creditToApply = 0,
  pointsToApply = 0,
  onCreditChange,
  onPointsChange,
}) {
  const copy = walletCopy[lang] || walletCopy.en;
  const maxDiscount = Math.floor(Number(grossTotal || 0) * 0.1);
  const availableCredit = Number(member?.credit_balance_jpy || 0);
  const availablePoints = Number(member?.points_balance || 0);

  return (
    <section className="rounded-[26px] border border-[#d8b769]/25 bg-black/35 p-5">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-sm font-semibold text-white">{copy.title}</p>
          <p className="mt-1 text-xs leading-5 text-white/55">{copy.description}</p>
        </div>
        <WalletCards className="h-5 w-5 text-[#d8b769]" />
      </div>

      <div className="mt-4 grid gap-3 sm:grid-cols-3">
        <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-4">
          <p className="text-xs uppercase tracking-[0.18em] text-white/45">{copy.credit}</p>
          <p className="mt-2 text-xl font-semibold text-[#f3d98b]">{formatJPY(availableCredit)}</p>
        </div>
        <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-4">
          <p className="text-xs uppercase tracking-[0.18em] text-white/45">{copy.points}</p>
          <p className="mt-2 text-xl font-semibold text-[#f3d98b]">{Number(availablePoints).toLocaleString()}</p>
        </div>
        <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-4">
          <p className="text-xs uppercase tracking-[0.18em] text-white/45">{copy.cap}</p>
          <p className="mt-2 text-xl font-semibold text-[#f3d98b]">{formatJPY(maxDiscount)}</p>
        </div>
      </div>

      <div className="mt-4 grid gap-3 sm:grid-cols-2">
        <label className="grid gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-white/45">
          {copy.useCredit}
          <input
            className="rounded-2xl border border-white/10 bg-white px-4 py-3 text-sm text-black outline-none"
            type="number"
            min="0"
            max={Math.min(availableCredit, maxDiscount)}
            value={creditToApply}
            onChange={(event) => onCreditChange?.(Number(event.target.value || 0))}
          />
        </label>
        <label className="grid gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-white/45">
          {copy.usePoints}
          <input
            className="rounded-2xl border border-white/10 bg-white px-4 py-3 text-sm text-black outline-none"
            type="number"
            min="0"
            max={Math.min(availablePoints, maxDiscount)}
            value={pointsToApply}
            onChange={(event) => onPointsChange?.(Number(event.target.value || 0))}
          />
        </label>
      </div>

      <p className="mt-3 flex items-center gap-2 text-xs leading-5 text-white/55">
        <Coins className="h-4 w-4 text-[#d8b769]" />
        {copy.note}
      </p>
    </section>
  );
}
